<template>
  <el-dialog title="备注" :visible.sync="dialogFormVisible" width="600px">
    <el-form ref="dataForm" label-position="left" label-width="110px" style="margin: 0 30px">
      <template>
        <el-form-item label="">
          <div style="display: flex; gap: 20px; padding-bottom: 10px">
            <div
              v-for="color in colors"
              :key="color.value"
              style="width: 30px; height: 30px; cursor: pointer; border-radius: 2px"
              :style="{
                backgroundColor: color.hex,
                boxShadow: remark_color === color.value ? '0 0 6px #333' : 'none'
              }"
              @click="remark_color = color.value"
            ></div>
          </div>
        </el-form-item>
        <el-form-item label="请输入备注">
          <el-input type="textarea" :rows="4" v-model="remark" placeholder="请输入备注内容" />
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { putRemark } from '@/api/orders'

export default {
  name: 'OrdersRemark',
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      sn: '',
      remark: '',
      remark_color: '',
      colors: [
        { value: 'red', hex: '#FF0000' },
        { value: 'green', hex: '#00B050' },
        { value: 'gray', hex: '#BFBFBF' },
        { value: 'blue', hex: '#0070C0' },
        { value: 'yellow', hex: '#FFFF00' }
      ]
    }
  },

  created() {},
  methods: {
    // 备注
    handleRemark(sn, remark, remark_color) {
      console.log(sn, remark, remark_color)
      this.sn = sn
      this.remark = remark
      this.remark_color = remark_color || 'red'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 保存
    saveData() {
      putRemark(this.sn, { remark: this.remark, remark_color: this.remark_color }).then(() => {
        this.$parent.fetchData()
        this.dialogFormVisible = false
        this.$parent.$notify({
          title: '成功',
          message: '备注改成功',
          type: 'success'
        })
      })
    }
  }
}
</script>
<style scoped>
.item-p {
  margin: 0;
  /* height: 1px; */
}
</style>
